import learnMorebg from "../../../assets/images/Images/Capacity Planning - Images/capacity-learn-more.png";
import platform from "../../../assets/images/Images/Capacity Planning - Images/platform_git.png";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
type Props = {};

const PlatformLearnMore = (props: Props) => {
  return (
    <>
      {/* mobile View */}

      <div className="d-block  d-md-none container px-30">
        <section
          className="mb-40 py-4 py-md-5 section-try"
          style={{
            backgroundImage: `url(${platform})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%",
          }}
        >
          <div className="row py-0 py-md-5">
            <div className="col-lg-6 col-md-6 col-sm-6"> &nbsp;</div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="paddingL">
                <p className="text-white-color fonts-800 font-30 line-35 mb-10 font-family-roboto pt-20 mobile-contactus-heading">
                  Learn More About Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-22 line-25 mb-10 font-family-roboto line15">
                  Explore how you can improve your field service operations with
                  Yantr.ai’s AI powered FSM platform.{" "}
                </p>
                <p className="text-white-color fonts-400 font-22 line-25 mb-20 font-family-roboto line15">
                  Schedule a demo today with our product experts!
                </p>
                <div className="d-none d-md-block">
                  <Link to={"/contact-us"}>
                    <Button
                      className="py-12 px-4 font-16 line-18 fonts-500 text-white-color font-family-roboto-flex size12"
                      onClick={() => {}}
                    >
                      Contact Us
                    </Button>
                  </Link>
                </div>
                <div className="d-block d-md-none">
                  <Link to={"/contact-us"}>
                    <Button
                      className="py-8 px-4 font-16 line-18 fonts-500 text-white-color font-family-roboto-flex size12"
                      onClick={() => {}}
                    >
                      Contact Us
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* website */}
      <div className="d-none d-md-block">
        <div className="container px-30">
          <section
            className="mb-60 py-3 py-md-5 section-try"
            style={{
              backgroundImage: `url(${learnMorebg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% 100%",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-6 col-sm-6"> &nbsp;</div>
              <div className="col-lg-6 col-md-6 col-sm-6">
                <div className="learn-more-desc">
                  <p className="text-white-color fonts-800 font-30 line-35 mb-10 font-family-roboto pt-20 mobile-contactus-heading">
                    Learn More About Yantr.ai
                  </p>
                  <p className="text-white-color fonts-400 font-22 line-25 mb-30 font-family-roboto">
                    Explore how you can improve your field service operations
                    with Yantr.ai’s AI powered FSM platform.{" "}
                  </p>
                  <p className="text-white-color fonts-400 font-22 line-25 mb-30 font-family-roboto">
                    Schedule a demo today with our product experts!
                  </p>
                  <div className="d-none d-md-block">
                    <Link to={"/contact-us"}>
                      <Button
                        className="py-12 px-4 font-16 line-18 fonts-500 text-white-color font-family-roboto-flex size12"
                        onClick={() => {}}
                      >
                        Contact Us
                      </Button>
                    </Link>
                  </div>
                  <div className="d-block d-md-none">
                    <Link to={"/contact-us"}>
                      <Button
                        className="py-8 px-4 font-16 line-18 fonts-500 text-white-color font-family-roboto-flex size12"
                        onClick={() => {}}
                      >
                        Contact Us
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PlatformLearnMore;
